import setFilterAsFavoriteCommand from './setFilterAsFavoriteCommand';
import unsetFilterAsFavoriteCommand from './unsetFilterAsFavoriteCommand';
import { upsertFilterCommand } from './upsertFilterCommand';

export const CommonSearchService = {
  setFilterAsFavoriteCommand,
  unsetFilterAsFavoriteCommand,
  upsertFilterCommand,
};
